import { render, staticRenderFns } from "./subscription-pricing-plans.vue?vue&type=template&id=5c61351e"
import script from "./subscription-pricing-plans.vue?vue&type=script&lang=js"
export * from "./subscription-pricing-plans.vue?vue&type=script&lang=js"
import style0 from "./subscription-pricing-plans.vue?vue&type=style&index=0&id=5c61351e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports